









import Vue from 'vue'
import { NO_PRINT_TAG } from '@/common/constants/printTag'

export default Vue.extend({
  name:'PrintTag',
  props: {
    tagName: {
      type: String,
      default: null
    }
  },
  computed: {
    isTagDisable(): boolean {
      return this.tagName === NO_PRINT_TAG
    }
  }
})
